import { z } from 'zod'

export const analyzeJobOfferResult = z.object({
    questions: z.array(z.string()),
    toneOfVoice: z.string(),
})

export type AnalyzeJobOfferResult = z.infer<typeof analyzeJobOfferResult>
